import { TypographyH3, TypographyP, TypographySmall } from '@talentmesh/ui/components/typography';
import type { ScoreItem } from '@talentmesh/utils';
import TestValidity from '../Personality/Components/TestValidity';
import { Chamomile } from '@/Components/Chamomile/Chamomile';
import UIStrings from '@/Utils/UIStrings';

interface ScoreOverviewProps {
    scoreOverviewTitle: string;
    scoreOverviewDescription: string;
    candidateFirstName: string;
    scores: ScoreItem[];
    overall: ScoreItem;
    testValidity?: number;
}

function ScoreOverview({
    scoreOverviewTitle,
    scoreOverviewDescription,
    candidateFirstName,
    scores,
    overall,
    testValidity,
}: ScoreOverviewProps) {
    return (
        <div className="bg-card rounded-b-xl border py-6">
            <div className="flex flex-col items-center justify-center gap-8">
                <div className="grid w-full grid-cols-12 items-start">
                    <div className="col-span-2" />
                    <div className="col-span-8">
                        <div className="flex flex-col items-center justify-center gap-2">
                            <TypographyH3 className="text-foreground text-center text-2xl leading-none">
                                {scoreOverviewTitle}
                            </TypographyH3>
                            <TypographyP className="text-foreground text-center">
                                {scoreOverviewDescription}
                            </TypographyP>
                        </div>
                    </div>
                    <div className="col-span-2 flex justify-end">
                        {testValidity ? <TestValidity value={testValidity} /> : null}
                    </div>
                </div>
                <Chamomile scores={scores} overall={overall} />
                <TypographySmall className="text-foreground">
                    {UIStrings.ScoreOverviewFooter(candidateFirstName, overall.value)}
                </TypographySmall>
            </div>
        </div>
    );
}

export default ScoreOverview;
